import useSharedStyles from '../shared.styles'

const useStyles = {
  screen: (isMobile: boolean) => ({
    ...useSharedStyles.screen(isMobile),
    alignItems: 'center',
    gap: 4,
    paddingY: isMobile ? 4.6 : 9,
    textAlign: 'center',
  }),
  title: {
    fontWeight: 500,
  },
  qrSection: {
    flexDirection: 'column',
    alignItems: 'center',
    gap: 4,
  },
  storeLinks: {
    justifyContent: 'center',
    flexWrap: 'wrap',
    gap: 3,
  },
}

export default useStyles
